import React from 'react';
import './App.css';
import MainPage from './containers/MainPage';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <MainPage/>
    </div>
  );
}

export default App;
